import axios from 'axios'
import router from '@/router'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import md5 from 'js-md5'

const service = axios.create({
	baseURL: '',
	timeout: 20000
})
let needLoadingRequestCount = 0

function showFullScreenLoading() {
	if (needLoadingRequestCount === 0) {
		store.dispatch('user/setLoading', true)
	}
	needLoadingRequestCount++
}

function tryHideFullScreenLoading() {
	if (needLoadingRequestCount <= 0) return
	needLoadingRequestCount--
	if (needLoadingRequestCount === 0) {
		store.dispatch('user/setLoading', false)
	}
}
// 请求拦截器
service.interceptors.request.use(
	config => {
		showFullScreenLoading()

		if (store.getters.token) {
			config.headers['Authorization'] = 'Bearer ' + getToken()
			config.headers['X-Request-Id'] = +new Date() + md5(store.getters.name)
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		// 响应状态码白名单，名单内的状态码可正常返回响应体, 10008-消息中心创建消息，解析excel时间过长，返回，但是会创建成功
		const responseCodeWhiteList = [10000, 10112, 1000, 10007, 10008, 10111, 10207, 200]
    const {
      data,
      config
    } = response
    if (data?.hasOwnProperty('data')
      && data?.data === null
      && window?.__bl
    ) {
      // window?.__bl.error(new Error(`响应体异常：URL:${config?.url}`), {
      //   filename: config?.url
      // })
      window?.__bl.setConfig({
        c1: config?.url ?? '',
        c2: JSON.stringify(config?.params ?? {}),
        c3: JSON.stringify(response?.data),
      })
    }
		const res = response?.data ?? {}
		setTimeout(() => {
			tryHideFullScreenLoading()
		}, 0)
		// 重置密码处理
		if (res.code === 10103) {
			/**
			 * @author 何硕
			 * Cannot read properties of undefined (reading 'data')
			 */
			router.push({ path: '/repassword' })
			return Promise.reject(res)
		}

		// 白名单正常返回响应内容
		if (responseCodeWhiteList.includes(Number(res.code))) return res
		else {
      // 优先提示sub_msg文案
			const msg = res.sub_msg || res.sub_message || res.message || ''
			msg?.length > 0 &&
				Message({
					message: `${msg}`,
					type: 'error',
					duration: 5 * 1000,
          showClose: true,
				})
			return Promise.reject(res || 'Error')
		}
	},
	error => {
		// 处理浏览器异常
		const errorMap = new Map([
			['Network Error', '网络异常，请检查网络链接！'],
			['timeout', '网络请求超时，请检查网络是否畅通，并刷新重试！']
		])
		setTimeout(() => {
			tryHideFullScreenLoading()
		}, 0)
		// 断网/超时优先校验
		if (errorMap.has(error.message)) {
      const { config } = error
      window?.__bl.setConfig({
        c1: `请求超时: ${config?.url}`,
        c2: JSON.stringify(config?.params ?? {}),
        c3: `${router?.currentRoute?.meta?.title}:${router?.currentRoute?.fullPath}`,
      })
			Message({
				message: errorMap.get(error.message),
				type: 'error',
				duration: 5 * 1000,
        showClose: true,
			})
      return Promise.reject(error)
		}
		// http状态码白名单，名单内的状态码不进行异常提示
		const errorStatusCodeWhiteList = [403]
		const errorHTTPStatusCode = error?.response?.status ?? null
		const code = error?.response?.data?.code ?? null
		const message = error?.response?.data?.message ?? ''
		// 用户登陆过期
		if (code && code === 10110) {
			MessageBox.confirm('用户信息已过期，请重新登录', '重新登录', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				store.dispatch('user/resetToken').then(() => {
					// location.reload()
          router.push({ path: '/login' })
				})
			})
      .catch(() => {})
		}
		// 白名单内的状态码不进行异常提示
		if (!errorStatusCodeWhiteList.includes(errorHTTPStatusCode)) {
			Message({
				message: `${message}`,
				type: 'error',
        showClose: true,
			})
		}
		return Promise.reject(error)
	}
)

export default service
